<template>
  <div class="sidebar-main">
    <div class="sidebar-head">
      <h5 class="sidebar-title">设备面板</h5>
      <div class="btn-box">
        <el-button
          size="small"
          @click="handleInfo"
          type="primary">基本信息</el-button>
        <el-button
          size="small"
          @click="handleClickDev"
          type="primary">添加设备</el-button>
      </div>
    </div>
    <div class="sidebar-menu">
      <sidebar-item
        @change="handleChange"
        @editDevice="handleClickDev('edit', $event)" ref="sidebarItem"></sidebar-item>
    </div>
    <!-- 基本信息弹窗 -->
    <edit-dialog
      :show="infoShow"
      :title="'基本信息'"
      :model="'infoShow'"
      :form="info"
      @success="handleAddInfo"
      @close="handleClose">
    </edit-dialog>
    <!-- 添加设备 -->
    <edit-device
      :show="addShow"
      :model="'addShow'"
      :form="device"
      :item="deviceItem"
      @success="handleDevice"
      @close="handleClose">
    </edit-device>
  </div>
</template>

<script>
  import { addCamera } from '@/api/monitor';
  import sidebarItem from './sidebar-item';
  import editDialog from './dialog';
  import editDevice from './dialog/device';
  export default {
    name: "sidebar",
    data() {
      return {
        infoShow: false,
        info: [
          { label: 'Appkey', key: 'appKey' },
          { label: 'Appsecret', key: 'appSecret' }
        ],
        addShow: false,
        deviceItem: {},
        device: [
          { label: '设备名称', key: 'name' },
          { label: '序列号', key: 'serialNumber' },
          { label: '验证码', key: 'verificationCode' }
        ]
      }
    },
    components: {
      sidebarItem,
      editDevice,
      editDialog
    },
    methods: {
      handleChange(item) {
        this.$emit('change', item)
      },
      //  点击添加基本信息
      handleInfo() {
        this.infoShow = true;
      },
      //  基本信息确认
      handleAddInfo(item) {
        location.reload();
      },
      //  点击编辑设备
      handleClickDev(key, item) {
        this.addShow = true;
        if (key === 'edit') {
          this.deviceItem = item;
        } else {
          this.deviceItem = {};
        }
      },
      //  设备添加成功
      handleDevice() {
        this.$refs.sidebarItem.getDeviceList();
      },
      //  关闭弹窗
      handleClose(key) {
        this[key] = false;
        if (key === 'addShow') {
          this.deviceItem = {}
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.sidebar-main {
  width: 250px;
  padding: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .sidebar-head {
    .sidebar-title {
      font-size: 18px;
    }
    .btn-box {
      margin-top: 10px;
    }
  }
  .sidebar-menu {
    margin-top: 20px;
    overflow-y: scroll;
  }
}

</style>
